// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';
import ReCAPTCHA from 'react-google-recaptcha';

import { RECAPCHA_API_KEY } from '../../../../config/apiKeys';
import { getCredentials, getMessage } from '../../store/selectors';
import * as contactActions from '../../store/actions';
import { Button, Input, Textarea } from '../../../../components';
import styles from './styles';

class Form extends Component {
  state = {
    value: null,
  };

  static propTypes = {
    classes: PropTypes.object,
    credentials: PropTypes.object,
    changeField: PropTypes.func,
    sendContactForm: PropTypes.func,
    message: PropTypes.object,
    resetForm: PropTypes.func,
    setMessage: PropTypes.func,
  };

  static defaultProps = {
    classes: {},
    credentials: {},
    changeField: () => { },
    sendContactForm: () => { },
    message: {},
    resetForm: () => { },
    setMessage: () => { },
  };

  onChangeInput = (value, name) => {
    this.props.changeField(value, name);
  };

  onSubmit = () => {
    if (this.state.value) {
      const { sendContactForm, credentials } = this.props;
      sendContactForm(credentials);
    } else {
      this.props.setMessage({ status: false, message: 'You should check reCAPTCHA' });
    }
  }

  componentWillUnmount() {
    this.props.resetForm();
  }

  onChange = (value) => {
    if (value) {
      this.props.setMessage({ status: null, message: null });
    }
    this.setState({ value });
  }

  render() {
    const { classes, message } = this.props;
    return (
      <div className={classes.mainContainer}>
        <form>
          <div className={classNames('form-group', classes.form)}>
            <Input
              fixedWidth
              label={'Name'}
              name={'Name'}
              value={this.props.credentials.Name}
              onChange={this.onChangeInput}
            />
            <Input
              fixedWidth
              label={'Email'}
              name={'EmailID'}
              inputType={'email'}
              value={this.props.credentials.EmailID}
              onChange={this.onChangeInput}
            />
            <Input
              fixedWidth
              label={'Subject'}
              name={'Subject'}
              value={this.props.credentials.Subject}
              onChange={this.onChangeInput}
            />
            <Textarea
              fixedWidth
              name={'Message'}
              label={'Message'}
              value={this.props.credentials.Message}
              onChange={this.onChangeInput}
            />
            <ReCAPTCHA
              sitekey={RECAPCHA_API_KEY}
              onChange={this.onChange}
            />
          </div>
        </form>
        {message.message && (
          <span
            className={classNames(classes.error, message.status
              ? classes.statusOk
              : classes.statusError)}
          >
            {message.message}
          </span>)}
        <Button
          text={'submit'}
          onPress={this.onSubmit}
          style={classes.buttonStyle}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    credentials: getCredentials(state),
    message: getMessage(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    sendContactForm: data => dispatch(contactActions.sendContactForm(data)),
    changeField: (value, name) => dispatch(contactActions.changeField(value, name)),
    resetForm: () => dispatch(contactActions.resetForm()),
    setMessage: message => dispatch(contactActions.setMessage(message)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Form));
